import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Indication } from '../../interfaces/indication.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';


@Injectable()
export class IndicationProvider {

  indications: Indication[];
  indicationSubject = new BehaviorSubject<number>(null);
  currentIndication = this.indicationSubject.asObservable();

  constructor(public http: HttpClient, public storage: Storage) {
  }

  getIndications() {
    return new Promise<Indication[]>((resolve, reject) => {
      this.storage.get("indications").then((data:Indication[]) => {
        this.indications = data;
        if(this.indications){
          this.orderByIndications(this.indications);
        }
        resolve(this.indications);
      });
    });
  }

  resetSelectedIndication(){ 
    this.indicationSubject.next(null);
    this.storage.remove("selectedIndication");
  }

  setSelectedIndication(selectedIndication): Promise<any>{
    this.indicationSubject.next(selectedIndication);
    return this.storage.set("selectedIndication", selectedIndication);
  }

  getSelectedIndication(){
    return this.storage.get("selectedIndication");
  }
  
  updateIndicationList(synchroList){
    return new Promise((resolve, reject) => {
      let add = this.addIndications(synchroList);
      let del = this.deleteIndications(synchroList);
      let up = this.updateIndications(synchroList);
      
      Promise.all([add, del, up]).then(data => { 
        this.storage.set("indications", this.indications).then(() => {
          resolve();
        });
      });
    });
  }

  deleteIndications(synchroList) {
    return new Promise((resolve, reject) => {
      let deletedSyncList = synchroList.Deleted;

      if(deletedSyncList.length > 0) {
        for(let i = 0; i < this.indications.length; i++){
            let cat = this.indications[i];
            if(deletedSyncList.indexOf(cat.IndicationId) !== -1){
                this.indications.splice(i, 1);
                i--;
            }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  updateIndications(synchroList){
    return new Promise((resolve, reject) => {
      let updatedSyncList = synchroList.Updated;

      if(updatedSyncList.length > 0){
        for(let i = 0; i < updatedSyncList.length; i++){
          let index = this.indications.findIndex(item => item.IndicationId == updatedSyncList[i].IndicationId)
          if(index !== -1){
            this.indications[index] = updatedSyncList[i];
          }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  addIndications(synchroList) {
    return new Promise((resolve, reject) => {
      let addedSyncList = synchroList.Added;

      if(addedSyncList.length > 0){
        for(let i = 0; i < addedSyncList.length; i++){
          let indication = addedSyncList[i];
          let found = this.indications.some(item => item.IndicationId == indication.IndicationId);
          if(!found){
              this.indications.push(indication);
          }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  orderByIndications(items){
    return items.sort((a, b) => (a.IndicationName).localeCompare(b.IndicationName))
  }

}



// WEBPACK FOOTER //
// ./src/providers/indication/indication.ts